import * as React from 'react';
import Svg, { SvgProps, Path } from 'react-native-svg';

const RightArrow20 = (props: SvgProps) => <Svg
  width='21'
  height='20'
  viewBox='0 0 21 20'
  fill='none'
  {...props}
>
  <Path
    d='M10.917 14.375L15.292 10M15.292 10L10.917 5.625M15.292 10L5.29199 10'
    stroke={props.color ?? '#0058AD'}
    strokeWidth='1.5'
    strokeMiterlimit='10'
    strokeLinecap='round'
    strokeLinejoin='round'
  />
</Svg>;
export default RightArrow20;
